import { useEffect, useRef, useState } from 'react';
import { IPoint } from '@meitu/saas-editor-core/es/version-types';

const useCursorMovePosition = (elemId: string) => {
    const [position, setPosition] = useState<IPoint | null>(null);
    const isIn = useRef(false);

    useEffect(() => {
        const elem = document.getElementById(elemId);

        if (!elem) {
            return;
        }
        const moveHandle = (e: any) => {
            if (!isIn.current) {
                return;
            }

            setPosition({ x: e.x, y: e.y });
        };
        document.addEventListener('mousemove', moveHandle);

        const mousedownHandle = () => {
            isIn.current = false;
            setPosition(null);
        };

        document.addEventListener('mousedown', mousedownHandle);

        const mouseupHandle = () => {
            isIn.current = true;
        };

        elem.addEventListener('mouseup', mouseupHandle);

        const enterHandle = () => {
            isIn.current = true;
        };
        elem.addEventListener('mouseenter', enterHandle);

        const outHandle = () => {
            isIn.current = false;
            setPosition(null);
        };
        elem.addEventListener('mouseout', outHandle);
        document.addEventListener('mouseout', outHandle);

        return () => {
            document.removeEventListener('mousemove', moveHandle);
            elem.removeEventListener('mouseenter', enterHandle);
            document.removeEventListener('mouseout', outHandle);
            elem.removeEventListener('mouseout', outHandle);
            document.removeEventListener('mousedown', mousedownHandle);
            elem.removeEventListener('mouseup', mouseupHandle);
        };
    }, [elemId]);

    return position;
};

export default useCursorMovePosition;
